var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-header"},[_c('h2',{staticClass:"section-header__header"},[_vm._v(_vm._s(_vm.$prismic.asText(_vm.header)))]),_vm._v(" "),_c('div',{staticClass:"section-header__teaser rich-text",domProps:{"innerHTML":_vm._s(_vm.$prismic.asHtml(_vm.teaser))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }